import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container pt-5" }
const _hoisted_2 = { class: "column mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title is-1 has-text-weight-bold" }, "Sergio Penagos", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle has-text-weight-medium" }, " Front-end Developer / Web Developer / Willing Relocate ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle-6 mb-3" }, " I come from a small place called Asgård, Since 2017 I've been a Frontend developer and currently I am looking for a new challenge in my career, besides I am willing to relocate. I've developed a few accessible and usability's websites and apps with different international and national teams. I also have knowledge in English or well I can have a good conversation. ", -1)

import VerticalTimeLine from "@/components/VerticalTimeLine.vue";
import ProjectsLine from "@/components/ProjectsLine.vue";
import SkillsLine from "@/components/SkillsLine.vue";
import ContactStep from "@/components/ContactStep.vue";
import FooterLine from "@/components/FooterLine.vue";
import ServicesOffer from "@/components/ServicesOffer.vue";
import pdfUrl from "@/assets/CV-2024.pdf";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const openPdfPreview = () => {
  window.open(pdfUrl, "_blank", "width=600,height=800");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("button", {
          onClick: openPdfPreview,
          class: "is-inline-flex is-align-items-center mb-6 is-justify-content-center is-clickable button"
        }, " See CV "),
        _createVNode(VerticalTimeLine),
        _createVNode(ProjectsLine),
        _createVNode(SkillsLine),
        _createVNode(ServicesOffer),
        _createVNode(ContactStep)
      ])
    ]),
    _createVNode(FooterLine)
  ], 64))
}
}

})